<p
  class="tw-mt-5 tw-px-5 tw-pb-0.5 tw-font-sans tw-text-base tw-text-eerie-black sm:tw-mt-10 sm:tw-px-0"
>
  {{ 'screens.notaryInformation.requiredFields' | translate }}
</p>
<form
  (ngSubmit)="notaryInformationFacade.onNext()"
  [formGroup]="notaryInformationFacade.notaryInformationForm"
  iaInvalidControlScroll
>
  <ia-panel class="tw-mt-4 tw-block">
    <div header class="">
      <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
        'screens.notaryInformation.introduction.title' | translate
      }}</span>
    </div>
    <div content class="tw-px-8 tw-pb-6 tw-pt-5">
      <div class="tw-flex tw-w-full tw-flex-col sm:tw-w-1/2">
        <label
          for="input-notary-information-notary"
          id="label-notary-information-notary"
          name="notary-information-notary"
        >
          <p class="tw-font-sans tw-font-semibold">
            {{ 'screens.notaryInformation.information.hasNotary.label' | translate }}
          </p>
          <p
            class="tw-pt-2 tw-font-sans tw-text-sm tw-text-gray"
            [innerHTML]="'screens.notaryInformation.information.hasNotary.description' | translate"
          ></p>
        </label>

        <div class="tw-mt-1">
          <ia-radio-button
            formControlName="hasNotary"
            value="YES"
            [disabled]="false"
            group="hasNotary"
          >
            <label
              for="input-notary-information-yes"
              id="label-notary-information-yes"
              class="tw-font-sans"
              name="notary-information-yes"
            >
              {{ 'screens.notaryInformation.information.hasNotary.yes' | translate }}
            </label>
          </ia-radio-button>
          <ia-radio-button
            formControlName="hasNotary"
            value="NO"
            [disabled]="false"
            group="hasNotary"
          >
            <label
              class="tw-font-sans"
              for="input-notary-information-no"
              id="label-notary-information-no"
              name="notary-information-no"
            >
              {{ 'screens.notaryInformation.information.hasNotary.no' | translate }}
            </label>
          </ia-radio-button>
          <ia-radio-button
            formControlName="hasNotary"
            value="IDK"
            [disabled]="false"
            group="hasNotary"
          >
            <label
              class="tw-font-sans"
              for="input-notary-information-no"
              id="label-notary-information-no"
              name="notary-information-no"
            >
              {{ 'screens.notaryInformation.information.hasNotary.unknown' | translate }}
            </label>
          </ia-radio-button>
          @if (
            notaryInformationFacade.hasNotary.touched && notaryInformationFacade.hasNotary.invalid
          ) {
            <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
              {{ 'screens.notaryInformation.information.hasNotary.error' | translate }}
            </p>
          }
        </div>

        @if (notaryInformationFacade.hasNotary.value === 'YES') {
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-last-name"
              id="label-notary-information-last-name"
              name="notary-information-last-name"
              >{{ 'screens.notaryInformation.information.name.label' | translate }}
              @if (
                !(
                  notaryInformationFacade.name.value.length ||
                  notaryInformationFacade.firstname.value.length
                )
              ) {
                {{ 'screens.notaryInformation.information.optional' | translate }}
              }
            </label>
            <input
              [error]="
                (notaryInformationFacade.name.touched &&
                  notaryInformationFacade.notaryInformationForm.hasError('fullNameError') &&
                  !notaryInformationFacade.name.value.length) ||
                false
              "
              [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="name"
              iaInput
              id="input-notary-information-last-name"
              data-test-id="input-notary-information-last-name"
              mask="A*"
              [specialCharacters]="[' -', 'space']"
              maxlength="32"
              name="name"
            />
            @if (
              notaryInformationFacade.name.touched &&
              notaryInformationFacade.notaryInformationForm.hasError('fullNameError') &&
              !notaryInformationFacade.name.value.length
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.name.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-first-name"
              id="label-notary-information-first-name"
              name="notary-information-first-name"
              >{{ 'screens.notaryInformation.information.firstname.label' | translate }}
              @if (
                !(
                  notaryInformationFacade.name.value.length ||
                  notaryInformationFacade.firstname.value.length
                )
              ) {
                {{ 'screens.notaryInformation.information.optional' | translate }}
              }
            </label>
            <input
              [error]="
                (notaryInformationFacade.firstname.touched &&
                  notaryInformationFacade.notaryInformationForm.hasError('fullNameError') &&
                  !notaryInformationFacade.firstname.value.length) ||
                false
              "
              [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="firstname"
              iaInput
              id="input-notary-information-first-name"
              data-test-id="input-notary-information-first-name"
              mask="A*"
              [specialCharacters]="[' -', 'space']"
              maxlength="32"
              name="firstname"
            />
            @if (
              notaryInformationFacade.firstname.touched &&
              notaryInformationFacade.notaryInformationForm.hasError('fullNameError') &&
              !notaryInformationFacade.firstname.value.length
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.firstname.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-email"
              id="label-notary-information-email"
              name="notary-information-email"
              >{{ 'screens.notaryInformation.information.email.label' | translate }}</label
            >
            <input
              [error]="
                notaryInformationFacade.email.touched && notaryInformationFacade.email.invalid
              "
              [patterns]="specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="email"
              iaInput
              id="input-notary-information-email"
              data-test-id="input-notary-information-email"
              mask="A*"
              maxlength="100"
              name="email"
            />
            @if (notaryInformationFacade.email.touched && notaryInformationFacade.email.invalid) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.email.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-phoneNumber"
              id="label-notary-information-phoneNumber"
              name="notary-information-phoneNumber"
              >{{ 'screens.notaryInformation.information.phoneNumber.label' | translate }}</label
            >
            <input
              [error]="
                notaryInformationFacade.phoneNumber.touched &&
                notaryInformationFacade.phoneNumber.invalid
              "
              [patterns]="successionFacade.specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="phoneNumber"
              iaInput
              id="input-notary-information-phoneNumber"
              data-test-id="input-notary-information-phoneNumber"
              mask="A*"
              maxlength="20"
              name="phoneNumber"
            />
            @if (
              notaryInformationFacade.phoneNumber.touched &&
              notaryInformationFacade.phoneNumber.invalid
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.phoneNumber.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-address"
              id="label-notary-information-address"
              name="notary-information-address"
              >{{ 'screens.notaryInformation.information.address.label' | translate }}</label
            >
            <input
              [error]="
                notaryInformationFacade.address.touched && notaryInformationFacade.address.invalid
              "
              [patterns]="successionFacade.specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="address"
              iaInput
              id="input-notary-information-address"
              data-test-id="input-notary-information-address"
              mask="A*"
              [specialCharacters]="[' -', 'space']"
              maxlength="50"
              name="address"
            />
            @if (
              notaryInformationFacade.address.touched && notaryInformationFacade.address.invalid
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.address.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-additional-address"
              id="label-notary-information-additional-address"
              name="notary-information-additional-address"
              >{{
                'screens.notaryInformation.information.complementaryAddress.label' | translate
              }}</label
            >
            <input
              [error]="
                notaryInformationFacade.completaryAddress.touched &&
                notaryInformationFacade.completaryAddress.invalid
              "
              [patterns]="successionFacade.specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="completaryAddress"
              iaInput
              id="input-notary-information-additional-address"
              data-test-id="input-notary-information-additional-address"
              mask="A*"
              [specialCharacters]="[' -', 'space']"
              maxlength="50"
              name="completaryAddress"
            />
            @if (
              notaryInformationFacade.completaryAddress.touched &&
              notaryInformationFacade.completaryAddress.invalid
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.complementaryAddress.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-postal-code"
              id="label-notary-information-postal-code"
              name="notary-information-postal-code"
              >{{ 'screens.notaryInformation.information.zipcode.label' | translate }}</label
            >
            <input
              [error]="
                notaryInformationFacade.zipcode.touched && notaryInformationFacade.zipcode.invalid
              "
              [patterns]="successionFacade.specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="zipcode"
              iaInput
              id="input-notary-information-postal-code"
              data-test-id="input-notary-information-postal-code"
              mask="A*"
              maxlength="20"
              name="zipcode"
            />
            @if (
              notaryInformationFacade.zipcode.touched && notaryInformationFacade.zipcode.invalid
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.zipcode.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-city"
              id="label-notary-information-city"
              name="notary-information-city"
              >{{ 'screens.notaryInformation.information.city.label' | translate }}</label
            >
            <input
              [error]="notaryInformationFacade.city.touched && notaryInformationFacade.city.invalid"
              [patterns]="successionFacade.specialCharactersNotAllowed"
              class="tw-w-75"
              formControlName="city"
              iaInput
              id="input-notary-information-city"
              data-test-id="input-notary-information-city"
              mask="A*"
              [specialCharacters]="[' -', 'space']"
              maxlength="32"
              name="city"
            />
            @if (notaryInformationFacade.city.touched && notaryInformationFacade.city.invalid) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.city.error' | translate }}
              </p>
            }
          </div>
          <div class="tw-mt-7.5 tw-flex tw-flex-col">
            <label
              class="tw-font-sans tw-text-base tw-font-semibold"
              for="input-notary-information-country"
              id="label-notary-information-country"
              name="notary-information-country"
              >{{ 'screens.notaryInformation.information.country.label' | translate }}</label
            >
            <ia-listbox2
              formControlName="country"
              [overlayOverrides]="listBoxOverlayConfig"
              class="tw-mt-2.5 tw-w-75"
              triggerId="input-notary-information-country"
              triggerAriaLabelledBy="label-notary-information-country"
            >
              <div *iaListbox2Placeholder>
                {{ 'screens.notaryInformation.information.country.placeholder' | translate }}
              </div>

              @for (option of successionFacade.listBoxItems.countries; track option.value) {
                <ia-listbox2-option [value]="option.value">
                  {{ option.label }}
                </ia-listbox2-option>
              }
            </ia-listbox2>
            @if (
              notaryInformationFacade.country.touched && notaryInformationFacade.country.invalid
            ) {
              <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
                {{ 'screens.notaryInformation.information.country.error' | translate }}
              </p>
            }
          </div>
        }
      </div>
    </div></ia-panel
  >

  @if (
    {
      isLoading: successionFacade.customerInformationIsLoading$ | async,
      isPrevious: successionFacade.isPreviousPageLoading$ | async,
      isNext: successionFacade.isNextPageLoading$ | async,
    };
    as vm
  ) {
    <div
      class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-space-x-2 sm:tw-flex-row"
    >
      <button
        (click)="notaryInformationFacade.onPrevious()"
        iaButton
        type="button"
        id="btn-notary-more-information-previous"
        data-test-id="btn-notary-more-information-previous"
        variant="secondary"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isPrevious"
      >
        {{ 'screens.notaryInformation.information.button.previous' | translate }}
      </button>
      <button
        iaButton
        type="submit"
        id="btn-notary-information-next"
        data-test-id="btn-notary-information-next"
        variant="primary"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isNext"
      >
        {{ 'screens.notaryInformation.information.button.next' | translate }}
      </button>
    </div>
  }
</form>
